module.exports = [{"name":"Documentação","url":"#","to":"documentation"},{"name":"SDK's","url":"#","to":"sdk"},{"name":"Referência API","url":"#","to":"api-documentation"},{"name":"Status da API","url":"#","to":"api-status"}]


//////////////////
// WEBPACK FOOTER
// ./src/database/developers_links.json
// module id = L9WD
// module chunks = 0